module.exports = __webpack_public_path__ + "fonts/nanumbarungothicultralight-webfont.8a97901a.woff2";